import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/programs/$programId",
)({
  component: RouteComponent,
  ssr: true,
});

function RouteComponent() {
  return <Outlet />;
}
